import { Component } from "react";
import { Auth, Hub } from "aws-amplify";
import MainPageNotAuthenticated from "../views/MainPageNotAuthenticated";
import { FullScreenCentered } from "./booking-instruments/LoadBookingInstrumentsInfo";
import { OwcProgressSpinner } from "@one/react";

const POST_LOGIN_REDIRECT_URL_KEY = "post_login_redirect_url";

// It's just for the sonar to fix major issue
const TheChildren = ({ children }) => <>{children}</>;

class Authentication extends Component {
  constructor(props) {
    super(props);
    this.getUser = this.getUser.bind(this);
    this.restorePostLoginUrl = this.restorePostLoginUrl.bind(this);
    this.handleAuthEvent = this.handleAuthEvent.bind(this);
    this.maxRedirectAuthRetries = 5;
    this.redirectAuthRetryCount = 0;
    this.authRetryTimer = null;
    this.unsubscribeAuthHub = null;
  }
  state = {
    user: null,
    loading: true,
  };

  getUser() {
    return Auth.currentAuthenticatedUser()
      .then((userData) => {
        this.redirectAuthRetryCount = 0;
        this.setState({ user: userData });
      })
      .catch(() => {
        const hasPendingRedirect = Boolean(
          sessionStorage.getItem(POST_LOGIN_REDIRECT_URL_KEY)
          || localStorage.getItem(POST_LOGIN_REDIRECT_URL_KEY)
        );

        if (hasPendingRedirect && this.redirectAuthRetryCount < this.maxRedirectAuthRetries) {
          this.redirectAuthRetryCount += 1;
          if (this.authRetryTimer) {
            clearTimeout(this.authRetryTimer);
          }
          this.authRetryTimer = setTimeout(() => {
            this.getUser();
          }, 400);
          return;
        }

        console.info("Not signed in");
      })
      .finally(() => this.setState({ loading: false }));
  }
  componentDidMount() {
    this.unsubscribeAuthHub = Hub.listen("auth", this.handleAuthEvent);
    this.getUser();
  }

  componentWillUnmount() {
    if (typeof this.unsubscribeAuthHub === "function") {
      this.unsubscribeAuthHub();
    }
    if (this.authRetryTimer) {
      clearTimeout(this.authRetryTimer);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.user && this.state.user) {
      this.restorePostLoginUrl();
    }
  }

  handleAuthEvent({ payload }) {
    const event = payload?.event;
    if (event === "signIn" || event === "cognitoHostedUI") {
      this.getUser();
    }
  }

  restorePostLoginUrl() {
    try {
      const storedUrl = sessionStorage.getItem(POST_LOGIN_REDIRECT_URL_KEY)
        || localStorage.getItem(POST_LOGIN_REDIRECT_URL_KEY);
      if (!storedUrl || typeof storedUrl !== "string") {
        return;
      }

      sessionStorage.removeItem(POST_LOGIN_REDIRECT_URL_KEY);
      localStorage.removeItem(POST_LOGIN_REDIRECT_URL_KEY);

      if (!storedUrl.startsWith("/")) {
        return;
      }

      const currentUrl = `${window.location.pathname}${window.location.search || ""}${window.location.hash || ""}`;
      if (currentUrl === storedUrl) {
        return;
      }

      window.location.assign(storedUrl);
    } catch (error) {
      console.warn("Unable to restore post-login URL", error);
    }
  }

  render() {
    if (this.state.loading)
      return (
        <FullScreenCentered data-testid="loader">
          <OwcProgressSpinner diameter={80} />
        </FullScreenCentered>
      );
    if (this.state.user === null) return <MainPageNotAuthenticated />;
    return <TheChildren>{this.props.children}</TheChildren>;
  }
}

export default Authentication;
